import { useEffect, useState } from 'react';
import { TBD_GRADE } from '../constants/grades';
var useStudentRow = function (student) {
    var notSeenStruggleNumber = student.notSeenStruggleNumber;
    var _a = useState(false), isActivityStream = _a[0], setIsActivityStream = _a[1];
    var _b = useState(0), clickCount = _b[0], setClickCount = _b[1];
    var _c = useState(notSeenStruggleNumber === 0), isCardsWasSeen = _c[0], setIsCardsWasSeen = _c[1];
    var hasTouchedCards = student.activityCalendar.filter(function (ac) { return ac.cardsTouched > 0; }).length > 0;
    var hasAssignments = student.activityCalendar
        .map(function (ac) { return ac.assignments; })
        .some(function (a) { return a.length > 0; });
    var isActive = hasTouchedCards || hasAssignments;
    var arrowBtnTooltip = (function () {
        if (!isActive) {
            return 'No activity this week';
        }
        return isActivityStream ? 'Hide activity' : 'Show activity';
    })();
    useEffect(function () {
        if (clickCount === 2) {
            setIsCardsWasSeen(true);
        }
    }, [clickCount]);
    return {
        isActivityStream: isActivityStream,
        setIsActivityStream: setIsActivityStream,
        clickCount: clickCount,
        setClickCount: setClickCount,
        isCardsWasSeen: isCardsWasSeen,
        arrowBtnTooltip: arrowBtnTooltip,
        isActive: isActive,
        isTbd: student.grade === TBD_GRADE,
    };
};
export { useStudentRow };
